import { SlotUnion } from "./Types";

export const injectScript = (src) => {
  const script = document.createElement("script");
  script.src = src;
  document.head.appendChild(script);
};

export const getSlotContainerID = (slot: SlotUnion): string => {
  if (typeof slot == "object") {
    return slot.getSlotElementId();
  } else {
    return slot;
  }
};

export const cdnPath = (path) => `//${process.env.ASSET_CDN}${path}`;
